const dateBeautiful = (date1) => {
  if (!date1) return '';
  let dateNew1 = date1.split('T');
  let dateNew2 = dateNew1[0].split('-');
  return dateNew2[2] + '-' + dateNew2[1] + '-' + dateNew2[0];
}
const getPlanName = (planId) => {
  if (!planId) return ''
  if (planId === 'fitres-001') return 'Plano Mensal';
  else if (planId === 'fitres-002') return 'Plano Trimestral';
  else if (planId === 'fitres-003') return 'Plano Semestral';
  else if (planId === 'fitres-004') return 'Plano Anual';
}
const setCookie = (cname, cvalue, exdays) => {
  let d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + encodeURIComponent(cvalue) + "; " + expires +";domain=.localhost; path=/";
  document.cookie = cname + "=" + encodeURIComponent(cvalue) + "; " + expires +";domain=.fisiologiadotreinamento.com; path=/";
}
function getCookie(cname)
{
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i=0; i<ca.length; i++)
  {
    let c = ca[i] ? ca[i].trim() : '';
    if (c.indexOf(name)==0)
    {
      return decodeURIComponent(decodeURIComponent(c.substring(name.length,c.length)));
    }
  }
  return "";
}
export {
  dateBeautiful,
  getPlanName,
  setCookie,
  getCookie
};
